// ADD TITLE
$('.upsell_products').first().find('.upsell_title').text('Related products');
// BOLTS AND SCREWS


$(document).on('click', '.upsell_products .quick-add-button-variants', function(){
    var dataPrdSmallName = $('.product-details-wrapper').attr('data-prd-small-name');
    const intervalId = setInterval(() => {
        if ($("#ShopNowContainer .swatch-items-wrapper").length > 0) {
            //  $("#ShopNowContainer .product-single-wrapper").hide();
            $("#ShopNowContainer .swatch-items-wrapper .swatch-element input").each(function(){
                var variantsGet = $(this).attr('value');
                if(dataPrdSmallName == variantsGet){
                  console.log(variantsGet);
                  $(this).next().trigger('click');
                }
                
                
            });
             $("#ShopNowContainer .product-single-wrapper").fadeIn();
            // setTimeout(() => {
            //         $("#ShopNowContainer .product-single-wrapper").fadeIn();
            //     }, 600);
            clearInterval(intervalId); // Stop the interval
            
        }
    }, 500);
    
});

// NUTS

function nutsRelatedPrd(){
var selectedVariant = $('.product-details-wrapper[data-prd-type="Nuts"] .swatch[data-option-index="0"] .swatch-element.active input').val();
$('.product-details-wrapper[data-prd-type="Nuts"]').attr('data-prd-small-name', selectedVariant);
// alert(selectedVariant);
var matchedCountBolts = 0;
$('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Bolts"]').hide();
$('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Bolts"] .swiper-slide').each(function(){
    var nutsproducts = $(this).attr('data-prd-upsell');
    if(selectedVariant == nutsproducts){
      console.log(nutsproducts); 
      $(this).addClass('releated_to_variants');
      $(this).show();
      matchedCountBolts++;
    }else {
      $(this).hide();  
    }
    
 });
 if(matchedCountBolts > 0){
    $('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Bolts"]').show();
 }

 var matchedCountScrews = 0;
$('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Screws"]').hide();
$('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Screws"] .swiper-slide').each(function(){
    var Screwsproducts = $(this).attr('data-prd-upsell');
    if(selectedVariant == Screwsproducts){
      console.log(Screwsproducts); 
      $(this).addClass('releated_to_variants');
      $(this).show();
      matchedCountScrews++;
    }else {
      $(this).hide();  
    }
    
 });
 if(matchedCountScrews > 0){
    $('.product-details-wrapper[data-prd-type="Nuts"] .upsell_products[uspell_type="Screws"]').show();
 }

}
nutsRelatedPrd();
// var clickVariant = $('.product-details-wrapper[data-prd-type="Nuts"] .swatch[data-option-index="0"] .swatch-element label');
$(document).on('click', '.product-details-wrapper[data-prd-type="Nuts"] .swatch[data-option-index="0"] .swatch-element label', function(){
  setTimeout(() => {
    nutsRelatedPrd();
  },1000)  
  
})


// WASHERS

function WashersRelatedPrd(){
var selectedVariant = $('.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element.active input').val();
$('.product-details-wrapper[data-prd-type="Washers"]').attr('data-prd-small-name', selectedVariant);
// alert(selectedVariant);
var matchedCountBolts = 0;
$('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Bolts"]').hide();
$('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Bolts"] .swiper-slide').each(function(){
    var nutsproducts = $(this).attr('data-prd-upsell');
    if(selectedVariant == nutsproducts){
      console.log(nutsproducts); 
      $(this).show();
      matchedCountBolts++;
    }else {
      $(this).hide();  
    }
    
 });
 if(matchedCountBolts > 0){
    $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Bolts"]').show();
 }

 var matchedCountScrews = 0;
$('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"]').hide();
$('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"] .swiper-slide').each(function(){
    var Screwsproducts = $(this).attr('data-prd-upsell');
    if(selectedVariant == Screwsproducts){
      console.log(Screwsproducts); 
      $(this).addClass('swiper-slide');
      $(this).show();
      matchedCountScrews++;
    }else {
      $(this).hide();  
    }
    
 });
//  alert(matchedCountScrews);
    if(matchedCountScrews > 0){
    $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"]').show();
 }
 

}
WashersRelatedPrd();
// var clickVariant = $('.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element label');

$(document).on('click', '.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element label', function(){
  // alert("clicked");
  setTimeout(() => {
    WashersRelatedPrd();
  },1000)  
  
});


//  var matchedCountScrews = 0;
// $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"]').hide();
// $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"] .releated_to_variants').each(function(){
//     var Screwsproducts = $(this).attr('data-prd-upsell');
//     if(selectedVariant == Screwsproducts){
//       console.log(Screwsproducts); 
//       $(this).addClass('swiper-slide');
//       $(this).show();
//       matchedCountScrews++;
//     }else {
//       $(this).removeClass('swiper-slide');
//       $(this).hide();  
//     }
    
//  });
// //  alert(matchedCountScrews);
//     if(matchedCountScrews > 0){
//     $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"]').show();
//  }
 

// }
// WashersRelatedPrd();
// // var clickVariant = $('.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element label');

// $(document).on('click', '.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element label', function(){
//   $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"]').hide();
//   $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"] .upsell_products_inner').removeClass('swiper');
//   setTimeout(() => {
//     $('.product-details-wrapper[data-prd-type="Washers"] .upsell_products[uspell_type="Screws"] .upsell_products_inner').addClass('swiper');
//   },500) 
//   // alert("clicked");
//   setTimeout(() => {
//     WashersRelatedPrd();
//   },1000)  
  
// });




// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.upsell_products_inner.swiper').forEach(function (el) {
//     var swiperId = el.id;

//     var swiper = new Swiper('#' + swiperId, {
//       slidesPerView: 3,
//       spaceBetween: 20,
//       navigation: {
//         nextEl: '#' + swiperId + ' .swiper-button-next',
//         prevEl: '#' + swiperId + ' .swiper-button-prev',
//       },
//       pagination: {
//         el: '#' + swiperId + ' .swiper-pagination',
//         clickable: true,
//       },
//       loop: true,
//       breakpoints: {
//         768: {
//           slidesPerView: 3,
//         },
//         0: {
//           slidesPerView: 2,
//         }
//       }
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  var swiperInstances = {};

  function initializeSwipers() {
    document.querySelectorAll('.upsell_products_inner.swiper').forEach(function (el) {
      var swiperId = el.id;

      // Destroy if already exists
      if (swiperInstances[swiperId]) {
        swiperInstances[swiperId].destroy(true, true);
      }

      // Reinitialize swiper
      swiperInstances[swiperId] = new Swiper('#' + swiperId, {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
          nextEl: '#' + swiperId + ' .swiper-button-next',
          prevEl: '#' + swiperId + ' .swiper-button-prev',
        },
        pagination: {
          el: '#' + swiperId + ' .swiper-pagination',
          clickable: true,
        },
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          0: {
            slidesPerView: 2,
          }
        }
      });
    });
  }

  // Initial Swiper setup
  initializeSwipers();

  // Define selector string instead of jQuery object

  // Bind click using delegated event
  $(document).on('click', '.product-details-wrapper[data-prd-type="Washers"] .swatch[data-option-index="0"] .swatch-element label', function () {
    // Destroy all swiper instances
    Object.keys(swiperInstances).forEach(function (id) {
      swiperInstances[id].destroy(true, true);
      delete swiperInstances[id];
    });

    // Reinitialize after 1500ms
    setTimeout(function () {
      initializeSwipers();
    }, 1500);
  });

  $(document).on('click', '.product-details-wrapper[data-prd-type="Nuts"] .swatch[data-option-index="0"] .swatch-element label', function () {
    // Destroy all swiper instances
    Object.keys(swiperInstances).forEach(function (id) {
      swiperInstances[id].destroy(true, true);
      delete swiperInstances[id];
    });

    // Reinitialize after 1500ms
    setTimeout(function () {
      initializeSwipers();
    }, 1500);
  });

});






